import { ITextChatMessage } from './../../model/ITextChatMessage';

export function mergeProgressiveMessages(messages, i: number, message: ITextChatMessage) {

    const maxLinksCount = 9;

    const newImages = (message.images || []);
    const oldText = (messages[i].text || '');
    const newText = (message.text || '');

    messages[i].text = oldText + newText;
    messages[i].images = [...(messages[i].images || []), ...newImages];
    messages[i].links = [...(messages[i].links || []), ...(message.links || [])].splice(0, maxLinksCount);

    if (message.ctx?.format === 'markdown') {
        if (messages[i].ctx) {
            messages[i].ctx.format = 'markdown';
        } else {
            messages[i].ctx = { format: 'markdown' };
        }
    }

    if (message.ctx?.final === true) {
        messages[i].ctx.final = message.ctx?.final;
    }
}